export const TestID = {
  AcceptInvitation: 'accept-invitation',
  AcceptInvitationAcceptButton: 'accept-invitation-accept-button',
  AcceptInvitationDeclineButton: 'accept-invitation-decline-button',
  AdminGuiExternalLink: 'admin-gui-external-link',
  AdminPowersToggleButton: 'admin-powers-toggle-button',
  AddJwtFormAddButton: 'add-jwt-form-add-button',
  AddJwtFormDescription: 'add-jwt-form-description',
  AddJwtFormName: 'add-jwt-form-name',
  AddJwtFormOwner: 'add-jwt-form-owner',
  AddJwtFormRole: 'add-jwt-form-role',
  AddPaymentMethodCard: 'add-payment-method-card',
  AnnouncementBanner: 'announcement-banner',
  AnnouncementBannerAnnouncementItem: 'announcement-banner-announcement-item',
  AnnouncementBannerCloseButton: 'announcement-banner-close-button',
  AnnouncementBannerTogglerButton: 'announcement-banner-toggler-button',
  AnnouncementBannerTogglerButtonIcon: 'announcement-banner-toggler-button-icon',
  Apology: 'apology',
  AppBarMenuLink: 'app-bar-menu-link',
  AvatarCustomConnectionURL: 'avatar-custom-connection-url',
  AvatarDefaultConnectionURL: 'avatar-default-connection-url',

  BasicInfoNotConnected: 'basic-info-not-connected',
  BasicInfoNotConnecting: 'basic-info-not-connecting',
  BasicInfoNoInfoToShow: 'basic-info-no-info-to-show',
  BasicInfoDiskUsage: 'basic-info-disk-usage',
  BasicServiceLevelAgreementRadioButton: 'basic-service-level-agreement-radio-button',
  BrowserListEntities: 'browser-list-entities',
  BrowserListEntity: 'browser-list-entity',

  CardList: 'card-list',
  CardListSortSelector: 'card-list-sort-selector',
  CardListSortSelectorMenu: 'card-list-sort-selector-menu',
  ChangelogBadgeIndicator: 'changelog-badge-indicator',
  ChangelogButton: 'changelog-button',
  ChangelogDialog: 'changelog-dialog',
  ChangelogDialogAutoOpenCheckbox: 'changelog-dialog-auto-open-checkbox',
  ChangelogDialogCloseButton: 'changelog-dialog-close-button',
  ChangelogEntry: 'changelog-entry',
  ChooseEnvironmentPanel: 'choose-environment-panel',
  CommandPalette: 'command-palette',
  CommandPaletteCreateEntity: 'command-palette-create-',
  CommandPaletteGoToNamespaceIdentifierItem: 'command-palette-go-to-namespace-identifier-item',
  CommandPaletteGoToNamespaceIdentifierText: 'command-palette-go-to-namespace-identifier-text',
  CommandPaletteHint: 'command-palette-hint',
  CommandPaletteIncludeInternalObjectsToggle: 'command-palette-include-internal-objects-toggle',
  CommandPaletteNothingFound: 'command-palette-nothing-found',
  CommandPaletteRecentSearch: 'command-palette-recent-search',
  CommandPaletteSearchInNamespace: 'command-palette-search-in-namespace',
  CommandPaletteSearchInput: 'command-palette-search-input',
  CommandPaletteSearchResultRow: 'command-palette-search-result-row',
  ComputeLevelPanel: 'compute-level-panel',
  ConnectButton: 'connect-button',
  ConnectingNetworkLinkButton: 'connecting-network-link-button',
  ConnectionFailedMessage: 'connection-failed-message',
  ConnectionFailedMessageDetailsLinkButton: 'connection-failed-message-details-link-button',
  ConnectionFailedModal: 'connection-failed-modal',
  ConnectToSubscriptionHibernatedMessage: 'connect-to-subscription-hibernated-message',
  ConnectToSubscriptionProvisioningMessage: 'connect-to-subscription-provisioning-message',
  ConnectToSubscriptionProvisioningFailedMessage:
    'connect-to-subscription-provisioning-failed-message',
  ConnectNetworkLinkButton: 'connect-network-link-button',
  ContactUsCard: 'contact-us-card',
  ContactUsCardLinkButton: 'contact-us-card-link-button',
  CopyUnsavedConfigMessage: 'copy-unsaved-config-message',
  CreateNewPaymentMethodLink: 'create-new-payment-method-link',
  CreateNewSubscriptionTitle: 'create-new-subscription-title',
  CreateSubscriptionInCloudRadioButton: 'create-subscription-in-cloud-radio-button',
  CreateSubscriptionInOnPremRadioButton: 'create-subscription-in-on-prem-radio-button',
  CustomConnectionStringInput: 'custom-connection-string-input',

  DashboardPageTitle: 'dashboard-page-title',
  DashboardSubscriptionCard: 'dashboard-subscription-card',
  DatahubObjectsPaletteButton: 'datahub-objects-palette-button',

  DatasetsInternalTab: 'datasets-internal-tab',
  DatasetsLogsTab: 'datasets-logs-tab',
  DatasetsPermissionsTab: 'datasets-permissions-tab',
  DatasetsQueuesTab: 'datasets-queues-tab',
  DatasetsStacktraceTab: 'datasets-stacktrace-tab',
  DatasetsToolsTab: 'datasets-tools-tab',
  DatasetsUserTab: 'datasets-user-tab',
  DatasetsVariablesTab: 'datasets-variables-tab',

  DnsForwardingAddRuleButton: 'dns-forwarding-add-rule-button',
  DnsForwardingDomainInput: 'dns-forwarding-domain-input',
  DnsForwardingRemoveRuleButton: 'dns-forwarding-remove-rule-button',
  DnsForwardingSaveButton: 'dns-forwarding-save-button',
  DnsForwardingSection: 'dns-forwarding-section',

  DatasetInspectorBrowserListEntityTitle: 'dataset-inspector-browser-list-entity-title',
  DatasetInspectorFilter: 'dataset-inspector-filter',
  DatasetInspectorFilterAll: 'dataset-inspector-filter-all',
  DatasetInspectorFilterDeleted: 'dataset-inspector-filter-deleted',
  DatasetInspectorFilterLatest: 'dataset-inspector-filter-latest',
  DatasetInspectorViewerEntityHeader: 'dataset-inspector-viewer-entity-header',
  DebugInfoNoInfoToDisplayMessage: 'debug-info-no-info-to-display-message',
  DebugInfoStacktraceCollapsePanel: 'debug-info-stacktrace-collapse-panel',
  DeleteActionButton: 'delete-action-button',
  DeleteSystem: 'delete-system',
  DeveloperEnvironmentRadioButton: 'developer-environment-radio-button',
  DeveloperProEnvironmentRadioButton: 'developer-pro-environment-radio-button',
  DisconnectNetworkLinkButton: 'disconnect-network-link-button',

  EditorPanels: 'editor-panels',
  EnterpriseServiceLevelAgreementRadioButton: 'enterprise-service-level-agreement-radio-button',
  EntityDeletedMessage: 'entity-deleted-message',
  EntityHasDeletedConfig: 'entity-has-deleted-config',
  EntityViewerNextButton: 'entity-viewer-next-button',
  EntityViewerPreviousButton: 'entity-viewer-previous-button',
  EntityViewerTotalEntities: 'entity-viewer-total-entities',
  EntitiesBrowsingMessage: 'entities-browsing-message',
  EntitiesHasChangedMessage: 'entities-has-changed-message',
  ErrorMessageContainerOnDeadLetterPostModal: 'error-message-container-on-dead-letter-post-modal',
  ExpansionPanelTitle: 'expansion-panel-title',

  FallbackPortalLink: 'fallback-portal-link',
  FilterTableContent: 'filter-table-content',
  FixedTypePriceLabel: 'fixed-type-price-label',
  FixedTypePriceTitleLabel: 'fixed-type-price-title-label',
  FlowsListAllTab: 'flows-list-all-tab',

  PipeInputExternalSourceEntities: 'pipe-input-external-source-entities',
  PipeInputFetchedRemoteEntities: 'pipe-input-fetched-remote-entities',
  PipeInputSourceEntities: 'pipe-input-source-entities',
  PipeInputUploadEntities: 'pipe-input-upload-entities',

  JsonEditorContainerDiv: 'json-editor-container-div',
  JsonComparePanel: 'json-compare-panel',
  JsonCompareLeftEditor: 'json-compare-left-editor',
  JsonCompareRightEditor: 'json-compare-right-editor',
  JsonWebTokenTabDetails: 'json-web-token-tab-details',
  JsonWebTokenTabExistingTokensHeader: 'json-web-token-tab-existing-tokens-header',
  JsonWebTokenTabHeader: 'json-web-token-tab-header',

  KeyValuePairKey: 'key-value-pair-key',
  KeyValuePairValue: 'key-value-pair-value',

  LiveUpdatesIndicator: 'live-updates-indicator',
  LiveUpdatesIndicatorWrapper: 'live-updates-indicator-wrapper',
  LoginButton: 'login-button',
  LoginEmailAndPasswordRequired: 'login-email-and-password-required',
  LoginErrorMessageCaptchaRequired: 'login-error-message-captcha-required',
  LoginForm: 'login-form',
  LoginPasswordInput: 'login-password-input',
  LoginRecaptcha: 'login-recaptcha',
  LoginUserNameInput: 'login-user-name-input',
  LoginWrongCredential: 'login-wrong-credential',

  MailToInfoAtSesamDotIOLink: 'mail-to-info-at-sesam-dot-io-link',
  MenuTogglerButton: 'menu-toggler-button',
  MenuTogglerPopOver: 'menu-toggler-pop-over',
  MultiComputeRadioButton: 'multi-compute-radio-button',

  NavBarCollapsed: 'nav-bar-collapsed',
  NavBarExpended: 'nav-bar-expended',
  NavBarMenuItem: 'nav-bar-menu-item',
  NavBarToggler: 'nav-bar-toggler',
  NetworkPolicyLink: 'network-policy-link',
  NewJwtModalDescription: 'new-jwt-modal-description',
  NewJwtModalDismissButton: 'new-jwt-modal-dismiss-button',
  NewJwtModalHeader: 'new-jwt-modal-header',
  NewSubscriptionCardPaymentMethodsLink: 'new-subscription-card-payment-methods-link',

  OriginFilterButton: 'origin-filter-button',
  OverviewPageTitle: 'overview-page-title',

  PaymentMethodCard: 'payment-method-card',
  PaymentMethodCardDeleteButton: 'payment-method-card-delete-button',
  PaymentMethodCardEditButton: 'payment-method-card-edit-button',
  PaymentMethodDeleteConfirmModal: 'payment-method-delete-confirm-modal',
  PaymentMethodDeleteModalCancelButton: 'payment-method-delete-modal-cancel-button',
  PaymentMethodDeleteModalDeleteButton: 'payment-method-delete-modal-delete-button',
  PaymentMethodFormAddButton: 'payment-method-form-add-button',
  PaymentMethodInputAddress1: 'payment-method-input-address-1',
  PaymentMethodInputCompanyNumber: 'payment-method-input-company-number',
  PaymentMethodInputDescription: 'payment-method-input-description',
  PaymentMethodInputName: 'payment-method-input-name',
  PaymentMethodInputNameOfResponsible: 'payment-method-input-name-of-responsible',
  PaymentMethodInputPhoneNumber: 'payment-method-input-phone-number',
  PaymentMethodTypeRadioGroup: 'payment-method-type-radio-group',
  PersistConnectionStringCheckbox: 'persist-connection-string-checkbox',
  PipeConfigJsonEditor: 'pipe-config-json-editor',
  PipeConfigTab: 'pipe-config-tab',
  PipeDashboardTab: 'pipe-dashboard-tab',
  PipeDeadLettersTab: 'pipe-dead-letters-tab',
  PipeDebugTab: 'pipe-debug-tab',
  PipeExecutionLogTab: 'pipe-execution-log-tab',
  PipeGraphTab: 'pipe-graph-tab',
  PipeIndexesTab: 'pipe-indexes-tab',
  PipeInferredSchemaTab: 'pipe-inferred-schema-tab',
  PipeInputTab: 'pipe-input-tab',
  PipeOutputTab: 'pipe-output-tab',
  PipeOverviewTab: 'pipe-overview-tab',
  PipePermissionsTab: 'pipe-permissions-tab',
  PipeSchemaButton: 'pipe-schema-button',
  PipeSchemaPanel: 'pipe-schema-panel',
  PipesInternalPipesTab: 'pipes-internal-pipes-tab',
  PipesListAllTab: 'pipes-list-all-tab',
  PipesPermissionsTab: 'pipes-permissions-tab',
  PipesPrototypePermissionsTab: 'pipes-prototype-permissions-tab',
  postEntitiesModalSubTitle: 'post-entities-modal-sub-title',
  postEntitiesModalTitle: 'post-entities-modal-title',
  PostEntityModalPostButton: 'post-entity-modal-post-button',
  PriceCalculatorExpectedDataSizeInput: 'price-calculator-expected-data-size-input',
  PriceCalculatorTotalPriceLabel: 'price-calculator-total-price-label',
  PriceCalculatorTotalPriceTitleLabel: 'price-calculator-total-price-title-label',
  PrivacyPolicyLink: 'privacy-policy-link',
  ProductionTestCIEnvironmentRadioButton: 'production-test-ci-environment-radio-button',

  RefreshEntitiesButton: 'refresh-entities-button',
  RefreshEntitiesLoadingButton: 'refresh-entities--loading-button',
  RepostAllDeadLettersEntitiesButton: 'repost-all-dead-letters-entities-button',
  RepostSelectedDeadEntityButton: 'repost-selected-dead-entity-button',
  RepostSelectedEntityButton: 'repost-selected-entity-button',
  RestoreDefaultConnectionLinkButton: 'restore-default-connection-link-button',

  SavePipeButton: 'save-pipe-button',
  SearchEntitiesTextField: 'search-entities-text-field',
  SearchPipeClickGoStatusHeader: 'search-pipe-click-go-status-header',
  SearchPipeEntitiesButton: 'search-pipe-entities-button',
  SearchPipeEntitiesCompletedStatusHeader: 'search-pipe-entities-completed-status-header',
  SearchPipeEntitiesInProgressStatusHeader: 'search-pipe-entities-in-progress-status-header',
  ShowDownstreamPipesButton: 'show-downstream-pipes-button',
  ShowUpstreamPipesButton: 'show-upstream-pipes-button',
  SearchTypeRadioButtons: 'search-type-radio-buttons',
  SelectAllCheckbox: 'select-all-checkbox',
  SelectedTableRowsLabel: 'selected-table-rows-label',
  ServerErrorPageTitle: 'server-error-page-title',
  ServiceLevelAgreementPanel: 'service-level-agreement-panel',
  SesamChangeLogLink: 'sesam-change-log-link',
  SesamHubPieChartLink: 'sesam-hub-pie-chart-link',
  SesamHubPieChartSystem: 'sesam-hub-pie-chart-system',
  SesamPricingLink: 'sesam-pricing-link',
  SesamSupportLink: 'sesam-support-link',
  SideMenuSesamCopyrightNotice: 'side-menu-sesam-copyright-notice',
  SignUpAgreementCheckbox: 'sign-up-agreement-checkbox',
  SignUpButton: 'sign-up-button',
  SignUpFormConfirmPasswordInput: 'sign-up-form-confirm-password-input',
  SignUpFormEmailInput: 'sign-up-form-email-input',
  SignUpFormNameInput: 'sign-up-form-name-input',
  SignUpFormPasswordInput: 'sign-up-form-password-input',
  SignUpLink: 'sign-up-link',
  SingleComputeRadioButton: 'single-compute-radio-button',
  StandardServiceLevelAgreementRadioButton: 'standard-service-level-agreement-radio-button',

  SubscriptionBasicsTitle: 'subscription-basics-title',
  SubscriptionCardActions: 'subscription-card-actions',
  SubscriptionCardHeader: 'subscription-card-header',
  SubscriptionCardText: 'subscription-card-text',
  SubscriptionsSelectorCurrentName: 'subscriptions-selector-current-name',
  SubscriptionsSelectorDashboardLink: 'subscriptions-selector-dashboard-link',
  SubscriptionsSelectorLink: 'subscriptions-selector-link',
  SubscriptionsSelectorNewSubscriptionLink: 'subscriptions-selector-new-subscription-link',
  SubscriptionsSelectorToggleButton: 'subscriptions-selector-toggle-button',
  SubscriptionsSelectorToggleMenu: 'subscriptions-selector-toggle-menu',
  SubscriptionsSettingsBasicTab: 'subscriptions-settings-basic-tab',
  SubscriptionsSettingsDNSTab: 'subscriptions-settings-dns-tab',
  SubscriptionsSettingsJWTTab: 'subscriptions-settings-jwt-tab',
  SubscriptionsSettingsLicenseTab: 'subscriptions-settings-license-tab',
  SubscriptionsSettingsMembersTab: 'subscriptions-settings-members-tab',
  SubscriptionsSettingsNetworkTab: 'subscriptions-settings-network-tab',
  SubscriptionsSettingsProductTab: 'subscriptions-settings-product-tab',
  SubscriptionsSettingsRolesTab: 'subscriptions-settings-roles-tab',
  SubscriptionsSettingsVPNTab: 'subscriptions-settings-vpn-tab',

  SystemsInternalSystemsTab: 'systems-internal-pipes-tab',
  SystemsListAllTab: 'systems-list-all-tab',
  SystemsPermissionsTab: 'systems-permissions-tab',
  SystemsPrototypePermissionsTab: 'systems-prototype-permissions-tab',

  TableRow: 'table-row',
  TermsOfServiceLink: 'terms-of-service-link',
  ToggleThemeButton: 'toggle-theme-button',
  ToggleLiveUpdatesButton: 'toggle-live-updates-button',
  TryReloadSiteAgainLink: 'try-reload-site-again-link',

  UserMenu: 'user-menu',
  UserMenuToggleButton: 'user-menu-toggle-button',
} as const;
